"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This class takes an element inside a list that scrolls and that list's
// element. It them scrolls the list to insure the passed in item is fully
// visible. It only scrolls if necessary.
var ScrollToItem = /** @class */ (function () {
    function ScrollToItem(itemElement, listElement) {
        this.item = itemElement;
        this.list = listElement;
    }
    ScrollToItem.prototype.scrollToItem = function () {
        if (!this.item) {
            return false;
        }
        if (this.itemTooHigh()) {
            this.scrollUpToItem();
        }
        else if (this.itemTooLow()) {
            this.scrollDownToItem();
        }
        return true;
    };
    ScrollToItem.prototype.itemTooHigh = function () {
        return this.listTop > this.itemTop;
    };
    ScrollToItem.prototype.itemTooLow = function () {
        return this.itemBottom > this.listBottom;
    };
    ScrollToItem.prototype.scrollUpToItem = function () {
        this.list.scrollTop = this.itemTop;
    };
    ScrollToItem.prototype.scrollDownToItem = function () {
        this.list.scrollTop = this.itemBottom - this.listHeight;
    };
    Object.defineProperty(ScrollToItem.prototype, "itemTop", {
        get: function () {
            return this.item.offsetTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollToItem.prototype, "itemBottom", {
        get: function () {
            return this.itemTop + this.item.offsetHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollToItem.prototype, "listBottom", {
        get: function () {
            return this.listTop + this.listHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollToItem.prototype, "listTop", {
        get: function () {
            return this.list.scrollTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollToItem.prototype, "listHeight", {
        get: function () {
            return this.list.offsetHeight;
        },
        enumerable: true,
        configurable: true
    });
    return ScrollToItem;
}());
exports.default = ScrollToItem;
//# sourceMappingURL=scroll_to_item.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/scroll_to_item.js
// module id = /k5S
// module chunks = 20 21